/* eslint-disable warp-drive/no-legacy-request-patterns */
import { service } from '@ember/service';
import Route from '@ember/routing/route';

import GroupType from '@linc-technologies/linced-common/enums/group-type';
import PersonType from '@linc-technologies/linced-common/enums/person-type';
import { hash } from '@linc-technologies/linced-common/utils/promise';
import moment from 'moment';

export default class BookingsRoute extends Route {
  // Services
  @service
  store;

  model() {
    let year = moment().year();
    return hash({
      groups: hash({
        current: this.store.query('group', { year }),
        next: this.store.query('group', { year: year + 1 }),
      }).then((groups) => {
        let mergedGroups = [...groups.current.slice(), ...groups.next.slice()];
        return mergedGroups.filter((group) => {
          // Don't include "MY" groups
          if (group.type === GroupType.GROUP) {
            return false;
          }
          // Don't include page-based autogroups
          // Page autogroup: Not in enum as they're auto-generated/managed.
          if (group.type === GroupType.AUTO && group.autoGroupType === 5) {
            return false;
          }
          return true;
        });
      }),
      staff: this.store.query('person', { type: PersonType.STAFF }),
    });
  }
}
